"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HoursOfOperationLabeled;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _utils = require("./utils");

require("./HoursOfOperationLabeled.css");

function HoursOfOperationLabeled(props) {
  var data = props.data,
      isHorizontal = props.isHorizontal,
      animated = props.animated,
      celled = props.celled,
      inlineHours = props.inlineHours;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List, {
    horizontal: isHorizontal,
    animated: animated,
    celled: celled,
    relaxed: true
  }, data.map(function (labelData) {
    var mainLabel = labelData[0];
    var hoursData = labelData[1];

    var mainList = /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.List, null, hoursData.map(function (_ref, idx) {
      var secondaryLabel = _ref.secondaryLabel,
          hoursValue = _ref.hoursValue;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Item, {
        key: secondaryLabel,
        style: !!secondaryLabel && idx !== 0 ? {
          marginTop: '1em'
        } : {
          marginTop: '0.25em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Content, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Header, {
        as: "h4"
      }, secondaryLabel, inlineHours && ": ".concat(hoursValue.join(' | '))), !inlineHours && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Description, null, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "unstyled-list"
      }, hoursValue.map(function (hour) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: hour
        }, hour);
      })))));
    }));

    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Item, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Content, null, mainLabel !== _utils.NO_LABEL && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Header, {
      as: "h3"
    }, mainLabel), mainList));
  }));
}